module.exports = __webpack_public_path__ + "img/hrblogo.64a6f076.png";